import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import oauthSagas from './oauth/saga';
import promotionSagas from './promotion/saga';

export default function* rootSaga() {
	yield all([authSagas(), oauthSagas(), promotionSagas()]);
}
